// extracted by mini-css-extract-plugin
module.exports = {"main":"makePayments_main__6ARTW","title":"makePayments_title__2rFQO"};